import { useEffect } from "react";

import { useCookieConsent } from "@/hooks/useCookieConsent";
import { useAdsConversionSharingCountry } from "@/lib/adsConversionSharing";
import {
  isLinkedInAdsRolloutCountry,
  setLinkedInAdsMeasurementState,
} from "@/lib/linkedInAdsMeasurement";

export function LinkedInAdsTag({
  partnerId,
  accountCreationConversionId,
  countryCode,
}: {
  partnerId: string;
  accountCreationConversionId: string;
  countryCode?: string;
}) {
  const {
    isAuthenticated,
    isConsentRequired,
    isConsentResolved,
    isGlobalPrivacyControlEnabled,
    marketingConsent,
    marketingConsentEnabled,
  } = useCookieConsent();
  const isRolloutCountry = isLinkedInAdsRolloutCountry(countryCode);
  const shouldShareAllConversions = useAdsConversionSharingCountry("linkedin", countryCode);
  const isRequiredConsentPending =
    !isAuthenticated &&
    isConsentRequired === true &&
    marketingConsent == null &&
    !isGlobalPrivacyControlEnabled;
  const isMeasurementConsentResolved =
    isConsentResolved &&
    (isAuthenticated || isConsentRequired !== undefined) &&
    !isRequiredConsentPending;
  const shouldClearAttribution =
    !isRolloutCountry ||
    isGlobalPrivacyControlEnabled ||
    (isMeasurementConsentResolved && !marketingConsentEnabled);
  const isMeasurementEligibilityResolved = isMeasurementConsentResolved || shouldClearAttribution;
  const measurementEnabled =
    isMeasurementConsentResolved &&
    marketingConsentEnabled &&
    Boolean(partnerId) &&
    Boolean(accountCreationConversionId) &&
    isRolloutCountry;

  useEffect(() => {
    setLinkedInAdsMeasurementState({
      enabled: measurementEnabled,
      isConsentResolved: isMeasurementEligibilityResolved,
      shouldClearAttribution,
      shouldShareAllConversions,
      configuredPartnerId: partnerId,
      configuredAccountCreationConversionId: accountCreationConversionId,
    });
    return () =>
      setLinkedInAdsMeasurementState({
        enabled: false,
        isConsentResolved: isMeasurementEligibilityResolved,
        shouldClearAttribution,
        configuredPartnerId: partnerId,
        configuredAccountCreationConversionId: accountCreationConversionId,
      });
  }, [
    accountCreationConversionId,
    isMeasurementEligibilityResolved,
    measurementEnabled,
    partnerId,
    shouldClearAttribution,
    shouldShareAllConversions,
  ]);

  return null;
}
